import React from "react";

export default function AmbientBg({ variant = "default" }) {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      <div
        className="ambient-blob"
        style={{
          width: 600, height: 600,
          background: "radial-gradient(circle, #FF4D8D 0%, transparent 70%)",
          top: -200, left: -200,
        }}
      />
      <div
        className="ambient-blob"
        style={{
          width: 700, height: 700,
          background: "radial-gradient(circle, #7B61FF 0%, transparent 70%)",
          top: 200, right: -250,
          animation: "float-slow 9s ease-in-out infinite",
        }}
      />
      {variant === "rich" && (
        <div
          className="ambient-blob"
          style={{
            width: 500, height: 500,
            background: "radial-gradient(circle, #FF9F5A 0%, transparent 70%)",
            bottom: -150, left: "30%",
            opacity: 0.35,
          }}
        />
      )}
      {/* subtle grain */}
      <div
        className="absolute inset-0 opacity-[0.025] mix-blend-screen"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence baseFrequency='0.85' numOctaves='2'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
        }}
      />
    </div>
  );
}
